var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2401 4.78237C7.53648 4.78237 5.35449 6.96482 5.35449 9.66906C5.35449 12.3733 7.53648 14.5558 10.2401 14.5558C12.9438 14.5558 15.1258 12.3733 15.1258 9.66906C15.1258 6.96482 12.9438 4.78237 10.2401 4.78237ZM10.2401 12.8451C8.49169 12.8451 7.06482 11.4179 7.06482 9.66906C7.06482 7.92024 8.49169 6.49307 10.2401 6.49307C11.9886 6.49307 13.4154 7.92024 13.4154 9.66906C13.4154 11.4179 11.9886 12.8451 10.2401 12.8451ZM15.3259 3.44336C14.6946 3.44336 14.1849 3.95323 14.1849 4.58462C14.1849 5.21601 14.6946 5.72588 15.3259 5.72588C15.9571 5.72588 16.4669 5.21839 16.4669 4.58462C16.4645 3.95085 15.9571 3.44336 15.3259 3.44336Z",
    fill: "url(#paint0_linear_14874_16190)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6862 9.555C18.6862 8.40409 18.6966 7.2636 18.632 6.11478C18.5674 4.78039 18.263 3.59612 17.2872 2.62035C16.3094 1.64249 15.1272 1.34017 13.7929 1.27553C12.642 1.2109 11.5015 1.22132 10.3527 1.22132C9.2018 1.22132 8.06134 1.2109 6.91254 1.27553C5.57817 1.34017 4.39393 1.64457 3.41817 2.62035C2.44033 3.5982 2.13802 4.78039 2.07338 6.11478C2.00875 7.26569 2.01917 8.40617 2.01917 9.555C2.01917 10.7038 2.00875 11.8464 2.07338 12.9952C2.13802 14.3296 2.44242 15.5139 3.41817 16.4896C4.39601 17.4675 5.57817 17.7698 6.91254 17.8345C8.06343 17.8991 9.20389 17.8887 10.3527 17.8887C11.5036 17.8887 12.644 17.8991 13.7929 17.8345C15.1272 17.7698 16.3115 17.4654 17.2872 16.4896C18.2651 15.5118 18.5674 14.3296 18.632 12.9952C18.6987 11.8464 18.6862 10.7059 18.6862 9.555ZM16.8515 14.4714C16.6993 14.8509 16.5158 15.1344 16.2218 15.4263C15.9278 15.7203 15.6464 15.9038 15.2669 16.056C14.1702 16.4917 11.5661 16.3937 10.3506 16.3937C9.13509 16.3937 6.52891 16.4917 5.43223 16.0581C5.05277 15.9059 4.76922 15.7224 4.47732 15.4284C4.18335 15.1344 3.99987 14.8529 3.84767 14.4735C3.414 13.3747 3.51199 10.7705 3.51199 9.555C3.51199 8.33945 3.414 5.73323 3.84767 4.63652C3.99987 4.25706 4.18335 3.9735 4.47732 3.6816C4.7713 3.3897 5.05277 3.20414 5.43223 3.05194C6.52891 2.61826 9.13509 2.71626 10.3506 2.71626C11.5661 2.71626 14.1723 2.61826 15.269 3.05194C15.6485 3.20414 15.932 3.38762 16.2239 3.6816C16.5179 3.97558 16.7013 4.25706 16.8535 4.63652C17.2872 5.73323 17.1892 8.33945 17.1892 9.555C17.1892 10.7705 17.2872 13.3747 16.8515 14.4714Z",
    fill: "url(#paint1_linear_14874_16190)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14874_16190",
    x1: 10.9107,
    y1: 3.44336,
    x2: 10.9107,
    y2: 14.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#B51EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14874_16190",
    x1: 10.3528,
    y1: 1.2207,
    x2: 10.3528,
    y2: 17.8893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#B51EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABA3D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0d203f4e1718ef397e64ebc2a07c84a5.svg";
export { ForwardRef as ReactComponent };